import { queryKeys } from "@/constants/queryKeyFactory";
import { useMutation, useQuery } from "@/hooks/api";
import {
  ApiResponse,
  PaginationParams,
  QueryOptions,
} from "@/interfaces/api.interface";
import { IRequest } from "@/interfaces/request.interface";
import { queryClient } from "@/lib/queryClient";
import { reqSvc } from "@/services/request.service";

export function useRequests(
  params: PaginationParams = {},
  options: QueryOptions = {}
) {
  return useQuery<ApiResponse<IRequest[]>>(
    queryKeys.request.list(params),
    () =>
      reqSvc.get<IRequest>({
        pageNumber: params.pageNumber,
        pageSize: params.pageSize,
        sort: params.sort,
        filter: params.filter,
        searchFilters: params.searchFilters,
      }),
    options
  );
}

export function useAllRequests(
  params: PaginationParams = {},
  options: QueryOptions = {}
) {
  return useQuery<ApiResponse<IRequest[]>>(
    queryKeys.request.all({ ...params }),
    () => reqSvc.getAll<IRequest>(params),
    options
  );
}

export function useCreateRequest(options: QueryOptions = {}) {
  return useMutation<ApiResponse<IRequest>, IRequest>(
    (data: IRequest) => reqSvc.create<IRequest>(data),
    {
      ...options,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.request.root,
        });
        queryClient.invalidateQueries({
          queryKey: queryKeys.levels.root,
        });
      },
      showLoader: false,
    }
  );
}

export function useUpdateRequest(options: QueryOptions = {}) {
  return useMutation<ApiResponse<IRequest>, { id: string; data: IRequest }>(
    ({ id, data }) => reqSvc.update<IRequest>(id, data),
    {
      ...options,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.request.root,
          refetchType: "active",
        });
      },
    }
  );
}
